import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { LcaService } from 'src/app/services/lca.service';
import { environment } from 'src/environments/environment';

// This Files upload will go as separate release as an enhancement
// import { UploadDocumentService } from '../../../services/upload-document.service';
import { distinctUntilChanged, map, take, takeUntil } from 'rxjs/operators';
import { acceptedFileTypes } from 'app-models';


@Component({
  selector: 'app-post-lca',
  templateUrl: './post-lca.component.html',
  styleUrls: ['./post-lca.component.scss']
})
export class PostLcaComponent implements OnInit {

  lcaPostingForm: FormGroup;
  minimumDate = new Date();
  htmlTemplate: string = ``;
  lcaDetailsSubscription$ = new Subject();
  fromDate;
  // Options for the dropdown and radio buttons
  daysOptions: number[] = [10, 15, 20, 30];
  takeDownOptions: any[] = [
    { label: 'Auto Take Down', 
      value: 'Auto Take Down' 
    }, 
    { label: 'Manual Take Down', 
      value: 'Manual Take Down' 
    }
  ];

  
  configurations = {
    inputMultipleFlag: false,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'LCADOC',
    entityId: 0,
    fileCategory: 'LCA',
    // This Files upload will go as separate release as an enhancement
    // listUploadedFiles: [],
    documentTypeRequired: true,
    docummentTypeCode: 'LCADOC',
    useCase: 'company',
    useCaseId: parseInt(sessionStorage.getItem('companyId')),
    useEntityId: false
  };

  jobPostingUrl = '';
  constructor(
    public dialogRef: MatDialogRef<PostLcaComponent>,
    @Inject(MAT_DIALOG_DATA) public lcaData,
    private fb: FormBuilder,
    private clipboard: Clipboard,
    private toastr: ToastrService,
    private lcaService: LcaService,
    private router: Router,
    // This Files upload will go as separate release as an enhancement
    // private uploadDocumentService: UploadDocumentService
  ) { }

  ngOnInit(): void {
    this.configurations.entityId = this.lcaData.id;

    // This Files upload will go as separate release as an enhancement, need to uncomment this after PROD release
    // this.getUpolodedFiles();

    const currentPath = window.location.pathname;
    // Remove the current state (if any) from the path
    const pathWithoutCurrentState = currentPath.split('/').slice(0, -1).join('/');
    // Append the new string
    const newPath = `${pathWithoutCurrentState}/internal-job-posting/`;

    this.jobPostingUrl = environment.appUrl + newPath + this.lcaData.companyName + '/' + this.lcaData.companyId
    this.lcaPostingForm = this.fb.group({
      lcaPostingDate: [this.lcaData.postedDate ? new Date(this.lcaData.postedDate) : new Date(), Validators.required],
      lcaExpiryDate: [this.lcaData.daysPosted ? this.lcaData.daysPosted : 30, Validators.required],
      takeDownOption: [!this.lcaData.isAutoTakeDown && this.lcaData.postedId ? 'Manual Take Down' : 'Auto Take Down', Validators.required],
    });
    this.htmlTemplate = `<button style="color: #fff; background-color: #19a0da; padding: 16px 8px;">
                          <a href="${this.jobPostingUrl}">VIEW JOB POSTING</a>
                        </button>`;

  }


  onDismiss() {
    this.dialogRef.close(false);
  }
  postLCAData() {
    if (this.lcaPostingForm.valid) {
      const formData = this.lcaPostingForm.value;
      const lcaPostingDate = formData.lcaPostingDate;
      const formattedLcaPostingDate = moment(lcaPostingDate).format(moment.HTML5_FMT.DATE)
      let takeDownOption = formData.takeDownOption;
      if(takeDownOption == 'Auto Take Down'){
        takeDownOption = true;
      }else if(takeDownOption == 'Manual Take Down'){
        takeDownOption = false;
      }
      const lcaExpiryDate = formData.lcaExpiryDate;
      const payload = {
        "lcaId": this.lcaData.id,
        "lcaPostingdate": formattedLcaPostingDate,
        "noOfDays":lcaExpiryDate,
        "isAutoTakeDown":takeDownOption,
        "postedLcaURL": this.jobPostingUrl,
        "buttonSnippet": this.htmlTemplate,
        "id": null,
      };
      if (this.lcaData.postedId) {
        payload.id = this.lcaData.postedId;
        this.lcaService.postLcaDetails(payload).pipe().subscribe(data => {
          this.toastr.success("Data saved successfully", 'Success');
          this.dialogRef.close(true);
        });
      } else {
        delete payload.id;
        this.lcaService.postLcaDetails(payload).pipe().subscribe(data => {
          this.toastr.success("Data saved successfully", 'Success');
          this.dialogRef.close(true);
        });
      }
    }else{
      console.log('Form is invalid');
    }
  }
  copyUrl() {
    this.clipboard.copy(this.jobPostingUrl);
    this.toastr.success('URL copied to clipboard', 'Success');
  }

  viewDocument(_data){
    const docPath = _data.fileLocation.substring(23);
    window.open(`${environment.docs}${docPath}`, '_blank');
  }

  // This Files upload will go as separate release as an enhancement
  // getUpolodedFiles() {
  //   this.uploadDocumentService.genericGetUploadDocument(this.configurations.useCase, this.configurations.useCaseId, this.configurations.categoryName, this.configurations.entityId, this.configurations.useEntityId).pipe(take(1)).subscribe((response) => {
  //     if (response['status'] === 200) {
  //       this.configurations.listUploadedFiles = response['data'];
  //       this.configurations = Object.assign({}, this.configurations);
  //     }
  //     else {
  //       this.configurations.listUploadedFiles = [];
  //       this.configurations = Object.assign({}, this.configurations);
  //     }
  //   });
  // }
 
}